<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  background-color: #409eff;
  color: #fff;
  line-height: 60px;
  text-align: center;
}

.el-menu {
  text-align: center;
}

.el-main {
  min-height: calc(100vh - 120px);
}
</style>